












































import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import PageTitle from "@/components/atoms/PageTitle.vue";
import SearchEmp from "@/components/organisms/SearchEmp.vue";
import Checkbox from "@/components/atoms/Checkbox.vue";
import AlertMessage from "@/components/atoms/AlertMessage.vue";
import { IAlertInfo } from "@/types";
import { EmployeesStore, LoginUserStore, OperationLogsStore } from "@/store";
import { IFetchEmployeesParameters } from "@/store/modules/employees";
import _ from "lodash";
// eslint-disable-next-line @typescript-eslint/no-var-requires
const VueTabulator = require("vue-tabulator");
const Tabulator = VueTabulator.TabulatorComponent;
import * as CONSTANTS from "@/common/constants";
import Utils from "@/common/utils";
import { ISearchEmpInfo, ITableOptions } from "@/types";
import { OperationLogs } from "@/store/modules/operationLogs";
import moment from "moment-timezone";
import MESSAGE from "@/assets/json/message.json";

interface ITableEmpInfo {
  employee_id: string;
  tt_emp_cd: string | null;
  tt_last_name: string | null;
  tt_first_name: string | null;
  company_name: string | null;
  tt_layer_department_name: string | null;
  tt_department_cd_1: string | null;
  tt_department_name_1: string | null;
  tt_department_cd_2: string | null;
  tt_department_name_2: string | null;
  tt_department_cd_3: string | null;
  tt_department_name_3: string | null;
  tt_department_cd_4: string | null;
  tt_department_name_4: string | null;
  tt_department_cd_5: string | null;
  tt_department_name_5: string | null;
  tt_retire_date: string | null;
  duplicate_flg: boolean;
  tt_birthday: string | null;
  tt_last_name_kana: string | null;
  tt_first_name_kana: string | null;
  tt_gender: number | null;
  tt_email: string | null;
  tt_tel: string | null;
  tt_title: string | null;
  tt_employment_ptn_name: string | null;
  tt_account_use_start_date: string | null;
  tt_enter_date: string;
  tt_employments_status: string | null;
}

@Component({
  components: { PageTitle, SearchEmp, Tabulator, Checkbox, AlertMessage },
})
export default class EmployeesList extends Vue {
  name: "EmployeesList";
  private isShowOnlyDuplicateFlgEmpList = false;
  private empTableList: ITableEmpInfo[] = [];
  private dangerAlertList: IAlertInfo[] = [];
  private targetDate: Date = moment().tz("Asia/Tokyo").toDate();

  @Watch("isShowOnlyDuplicateFlgEmpList")
  onChanged(isShowOnlyDuplicateFlgEmpList: boolean) {
    const tabulator: any = this.refs.tabulator;
    const tabulatorInstance = tabulator.getInstance();
    if (isShowOnlyDuplicateFlgEmpList) {
      tabulatorInstance.setFilter("duplicate_flg", "=", true);
    } else {
      tabulatorInstance.clearFilter();
    }
  }

  get refs() {
    return this.$refs;
  }

  get title(): string {
    return "職員一覧";
  }

  private setEmpTableList(): void {
    this.isShowOnlyDuplicateFlgEmpList = false;
    let empList: ITableEmpInfo[] = [];
    const employees = EmployeesStore.getEmployees;

    if (employees.length === 0) {
      this.dangerAlertList = [
        {
          item: "NO_DATA",
          message: MESSAGE.EI005,
        },
      ];
      this.empTableList = empList;
      return;
    }

    for (let empInfo of employees) {
      empList.push({
        company_name: empInfo.company_name,
        tt_layer_department_name: empInfo.tt_layer_department_name,
        tt_department_cd_1: empInfo.tt_department_cd_1,
        tt_department_name_1: empInfo.tt_department_name_1,
        tt_department_cd_2: empInfo.tt_department_cd_2,
        tt_department_name_2: empInfo.tt_department_name_2,
        tt_department_cd_3: empInfo.tt_department_cd_3,
        tt_department_name_3: empInfo.tt_department_name_3,
        tt_department_cd_4: empInfo.tt_department_cd_4,
        tt_department_name_4: empInfo.tt_department_name_4,
        tt_department_cd_5: empInfo.tt_department_cd_5,
        tt_department_name_5: empInfo.tt_department_name_5,
        tt_emp_cd: empInfo.tt_emp_cd,
        tt_last_name: empInfo.tt_last_name,
        tt_first_name: empInfo.tt_first_name,
        tt_last_name_kana: empInfo.tt_last_name_kana,
        tt_first_name_kana: empInfo.tt_first_name_kana,
        tt_birthday: empInfo.tt_birthday,
        tt_gender: empInfo.tt_gender,
        tt_email: empInfo.tt_email,
        tt_title: empInfo.tt_title,
        tt_tel: empInfo.tt_tel,
        tt_enter_date: empInfo.tt_enter_date,
        tt_account_use_start_date: empInfo.tt_account_use_start_date,
        tt_retire_date: empInfo.tt_retire_date,
        tt_employment_ptn_name: empInfo.tt_employment_ptn_name,
        tt_employments_status: empInfo.tt_employments_status,
        employee_id: empInfo.employee_id,
        duplicate_flg: empInfo.duplicate_flg,
      });
    }

    this.empTableList = empList;
  }

  private async onClickSearchButton(empInfo: ISearchEmpInfo): Promise<void> {
    try {
      Utils.showTransparentLoadingModal(this.$bvModal);
      this.clearAlertList();

      this.targetDate = empInfo.target_date;
      const date = Utils.getApiRequestFormatDate(empInfo.target_date);
      if (!date) return;
      let param: IFetchEmployeesParameters = {
        user_id: LoginUserStore.getLoginUser.user_id,
        target_date: date,
      };
      if (empInfo.emp_cd) param.emp_cd = empInfo.emp_cd;
      if (empInfo.last_name) param.last_name = empInfo.last_name;
      if (empInfo.first_name) param.first_name = empInfo.first_name;
      if (empInfo.last_name_kana) param.last_name_kana = empInfo.last_name_kana;
      if (empInfo.first_name_kana)
        param.first_name_kana = empInfo.first_name_kana;
      if (empInfo.company_id) param.company_id = empInfo.company_id;
      if (empInfo.department_id) param.department_id = empInfo.department_id;

      await EmployeesStore.fetchEmployees(param);
      this.setEmpTableList();
    } catch (errorInfos) {
      console.error(errorInfos);
      if (errorInfos) {
        if (Array.isArray(errorInfos)) {
          errorInfos.forEach((error: any) => {
            if (error.item && error.message) {
              this.dangerAlertList.push({
                item: error.item,
                message: error.message,
              });
            }
          });
        }
      }
      if (this.dangerAlertList.length == 0) {
        this.dangerAlertList.push(Utils.getCommonAlertInfo());
      }
    } finally {
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  private async onClickDownloadEmpList(): Promise<void> {
    try {
      Utils.showTransparentLoadingModal(this.$bvModal);
      this.clearAlertList();

      await OperationLogsStore.recordOperationLogs({
        user_id: LoginUserStore.getLoginUser.user_id,
        operation_class: OperationLogs.OPERATION_CLASS.DOWNLOAD_FSM_CSV,
      });

      const tabulator: any = this.refs.tabulator;
      const tabulatorInstance = tabulator.getInstance();
      const fileFormatter = function (
        list: any[],
        options: any,
        setFileContents: any
      ) {
        let delimiter = options && options.delimiter ? options.delimiter : ",";
        let fileContents: string[] = [];
        let headers: string[] = [];

        list.forEach(function (row) {
          let item: string[] = [];

          switch (row.type) {
            case "group":
              console.warn(
                "Download Warning - CSV downloader cannot process row groups"
              );
              break;

            case "calc":
              console.warn(
                "Download Warning - CSV downloader cannot process column calculations"
              );
              break;

            case "header":
              row.columns.forEach(function (col: any, i: number) {
                if (col && col.depth === 1) {
                  headers[i] =
                    typeof col.value == "undefined" || col.value === null
                      ? ""
                      : '"' + String(col.value).split('"').join('""') + '"';
                }
              });
              break;

            case "row":
              row.columns.forEach(function (col: any) {
                if (col) {
                  switch (typeof col.value) {
                    case "object":
                      col.value = JSON.stringify(col.value);
                      break;

                    case "undefined":
                      col.value = "";
                      break;
                    default:
                      if (col.value === null) {
                        col.value = "";
                        break;
                      }
                  }

                  item.push(
                    '"' + String(col.value).split('"').join('""') + '"'
                  );
                }
              });

              fileContents.push(item.join(delimiter));
              break;
          }
        });

        if (headers.length) {
          fileContents.unshift(headers.join(delimiter));
        }

        let fileContentsToString = fileContents.join("\r\n");

        if (options.bom) {
          fileContentsToString = "\uFEFF" + fileContentsToString;
        }

        setFileContents(fileContentsToString, "text/csv");
      };

      let fileName = "施設基準管理システム連携用CSV_";
      let date: Date = moment().tz("Asia/Tokyo").toDate();
      if (_.isDate(this.targetDate)) {
        date = this.targetDate;
      }
      const year: number = date.getFullYear();
      const month: number = date.getMonth() + 1;
      const day: number = date.getDate();
      fileName += `${year}${Utils.getZeroPadding(
        String(month),
        2
      )}${Utils.getZeroPadding(String(day), 2)}`;
      fileName += ".csv";

      // CSVダウンロード
      tabulatorInstance.download(fileFormatter, fileName, {
        bom: true,
      });
    } catch (e) {
      console.error(e);
      this.dangerAlertList = [Utils.getCommonAlertInfo()];
    } finally {
      Utils.hideTransparentLoadingModal(this.$bvModal);
    }
  }

  get tableOptions(): ITableOptions {
    return {
      layout: "fitDataStretch",
      pagination: "local",
      paginationSize: 30,
      columns: [
        {
          title: "職員ID",
          field: "employee_id",
          sorter: "string",
          width: 250,
        },
        {
          title: "職員番号",
          field: "tt_emp_cd",
          sorter: "string",
          width: 250,
        },
        {
          title: "メールアドレス",
          field: "tt_email",
          visible: false,
          download: true,
        },
        {
          title: "姓",
          field: "tt_last_name",
          visible: false,
          download: true,
        },
        {
          title: "名",
          field: "tt_first_name",
          visible: false,
          download: true,
        },
        {
          title: "姓（フリガナ）",
          field: "tt_last_name_kana",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "名（フリガナ）",
          field: "tt_first_name_kana",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "性別",
          field: "tt_gender",
          visible: false,
          download: true,
          accessor: (value: number): string => {
            if (value === CONSTANTS.TT_GENDER_MEN) {
              return "男性";
            }
            if (value === CONSTANTS.TT_GENDER_WOMEN) {
              return "女性";
            }
            return "";
          },
        },
        {
          title: "生年月日",
          field: "tt_birthday",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isString(value)) {
              return value.replace(/-/g, "/");
            }
            return "";
          },
        },
        {
          title: "電話番号",
          field: "tt_tel",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "病院",
          titleDownload: "病院名",
          field: "company_name",
          sorter: "string",
          width: 250,
        },
        {
          title: "所属",
          field: "tt_layer_department_name",
          sorter: "string",
          width: 250,
          download: false,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "名前",
          field: "emp_name",
          sorter: "string",
          width: 300,
          download: false,
          mutator: (value: any, data: ITableEmpInfo): string => {
            let empName = "";
            if (data.tt_last_name !== null) {
              empName += data.tt_last_name;
            }
            if (empName !== "") {
              empName += " ";
            }
            if (data.tt_first_name !== null) {
              empName += data.tt_first_name;
            }
            return empName;
          },
        },
        {
          title: "所属1コード",
          field: "tt_department_cd_1",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属1名称",
          field: "tt_department_name_1",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属2コード",
          field: "tt_department_cd_2",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属2名称",
          field: "tt_department_name_2",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属3コード",
          field: "tt_department_cd_3",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属3名称",
          field: "tt_department_name_3",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属4コード",
          field: "tt_department_cd_4",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属4名称",
          field: "tt_department_name_4",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属5コード",
          field: "tt_department_cd_5",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "所属5名称",
          field: "tt_department_name_5",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "役職",
          field: "tt_title",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "就業パターン名",
          field: "tt_employment_ptn_name",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "TimeTappsアカウント利用開始日",
          field: "tt_account_use_start_date",
          visible: false,
          download: true,
          mutator: (value: string | null): string => {
            if (_.isString(value)) {
              return value.replace(/-/g, "/");
            }
            return "";
          },
        },
        {
          title: "入社日",
          field: "tt_enter_date",
          visible: false,
          download: true,
          mutator: (value: string | null): string => {
            if (_.isString(value)) {
              return value.replace(/-/g, "/");
            }
            return "";
          },
        },
        {
          title: "退職日",
          field: "tt_retire_date",
          sorter: "string",
          width: 200,
          mutator: (value: any): string => {
            if (_.isString(value)) {
              return value.replace(/-/g, "/");
            }
            return "";
          },
        },
        {
          title: "契約形態",
          field: "tt_employments_status",
          visible: false,
          download: true,
          accessor: (value: string | null): string => {
            if (_.isNil(value)) {
              return "";
            }
            return value;
          },
        },
        {
          title: "重複",
          field: "duplicate_flg",
          minWidth: 100,
          cssClass: "text-center",
          formatter: (cell: any): string => {
            const isDuplicateFlg: boolean = cell.getValue();
            if (isDuplicateFlg) {
              return '<i class="fas fa-exclamation-triangle" style="color: orange"></i>';
            }
            return "";
          },
          accessor: (value: boolean): string => {
            if (value) {
              return "有";
            }
            return "";
          },
        },
      ],
    };
  }

  private clearAlertList(): void {
    this.dangerAlertList = [];
  }
}
